<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select v-model='theLogInstance' clearable @change="theLogInstanceChange" size="small" placeholder="选择方法">
          <el-option
              v-for="item in theLogInstanceAll"
              :key="item.name"
              :label="item.label+'-'+item.name"
              :value="item.name" >
          </el-option>
        </el-select>
        <el-input
          v-model="getSysMsgErrorGlobalList_data.smegUrl"
          placeholder="请输入请求接口"
          clearable
          size='small'
          style="max-width:200px;"/>
        <el-button
          v-click.getSysMsgErrorGlobalList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
    </el-row>

    <mytable ref="getSysMsgErrorGlobalList"
      :tableColums='tableColums_getSysMsgErrorGlobalList'
      api='getSysMsgErrorGlobalList::smegId'
      updateapi='updateSysMsgErrorGlobalStatus'
      :height="H-165" >
    </mytable>

    <!-- 错误详情弹窗 -->
    <el-dialog title="详情" :visible.sync="detailShow" width="80%" :before-close="detailClose" top="5vh">
      <div style="max-height: 72vh; overflow-y: auto;">
        <!-- 基础信息 -->
        <el-descriptions :column="2" border :labelStyle="{
          color: '#409EFF',
          textAlign: 'center',
          width: '120px',
          fontSize: '12px'
        }" :contentStyle="{ fontSize: '12px' }">
          <el-descriptions-item label="ID">{{ detailRow.smegId }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <span :style="{ color: detailRow.smegStatus == 1 ? '#F56C6C' : '#67C23A' }">
              {{ detailRow.smegStatus == 1 ? '未处理' : '已处理' }}
            </span>
          </el-descriptions-item>
          <el-descriptions-item label="服务名">{{ detailRow.smegInstance || '-' }}</el-descriptions-item>
          <el-descriptions-item label="用户名">{{ detailRow.smegUserName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="请求接口" :span="2">{{ detailRow.smegUrl || '-' }}</el-descriptions-item>
          <el-descriptions-item label="参数" :span="2">
            <span style="word-break: break-all;">{{ detailRow.smegParams || '-' }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="备注" :span="2">{{ detailRow.smegDes || '-' }}</el-descriptions-item>
          <el-descriptions-item label="处理描述" :span="2">{{ detailRow.smegHandlerDes || '-' }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ detailRow.createtime || '-' }}</el-descriptions-item>
          <el-descriptions-item label="归属">{{ detailRow.ownership || '-' }}</el-descriptions-item>
        </el-descriptions>
        <!-- 错误信息：格式化后的堆栈文本 -->
        <div style="margin-top: 15px;">
          <div style="margin-bottom: 8px; color: #409EFF; font-weight: bold;">错误信息</div>
          <pre style="margin: 0; padding: 12px; background: #f5f7fa; border: 1px solid #e4e7ed; border-radius: 4px; font-size: 12px; line-height: 1.6; white-space: pre-wrap; word-break: break-all; max-height: 360px; overflow-y: auto;">{{ detailMsg }}</pre>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      theLogInstanceAll:[
        {name:"appcenter",label:"app和小程序"},
        {name:"opportunity",label:"后台管理"},
        {name:"receipt",label:"其他"},
        {name:"trainingmsg",label:"消息"},
      ],
      srelMethod:"",
      // 详情弹窗状态
      detailShow: false,
      detailRow: {},
      tableColums_getSysMsgErrorGlobalList: {
        $selection: false,

        smegUserName: ['用户名',100,],
        smegInstance: ['服务名',160,],
        smegUrl: ['请求接口',200,],
        smegParams: ['参数',200,],
        smegMsg: '错误信息',
        smegDes: '备注',
        createtime: ['创建时间',160,],
        smegStatus: ['状态',110,'@v-if: 1:未处理#danger, 2:已处理#success '],
        $operation: [
          '操作', 200,
          // 查看错误详情（不依赖后端权限接口，直接用列表行数据展示）
          `@text: 详情#success @click: handelDetail($row)`,
          this.updateSysMsgErrorGlobalStatus && `@text: 编辑状态#success
           @v-if: $row.smegStatus == 1
           @click: _confirm('确定要更新已处理吗?')
                   .trigger('updateSysMsgErrorGlobalStatus',{smegId:$row.smegId})
                   .trigger('getSysMsgErrorGlobalList')
          `,
        ],
      },

    };
  },

  watch: {

  },

  computed: {
    // 将后端返回的 smegMsg（Java 异常 JSON 字符串）格式化为可读的堆栈文本
    detailMsg() {
      const msg = this.detailRow.smegMsg;
      if (!msg) return '无';
      // 部分错误信息前面会带有非 JSON 文本（如 "syntax error..."），定位到首个 '{' 再解析
      const start = msg.indexOf('{');
      if (start === -1) return msg;
      const prefix = start > 0 ? msg.slice(0, start).trim() : '';
      try {
        const obj = JSON.parse(msg.slice(start));
        const lines = [];
        if (prefix) lines.push(prefix);
        // 异常类型
        lines.push(obj['@type'] || 'Exception');
        // 异常描述
        const message = obj.localizedMessage || obj.message;
        if (message) lines.push('Message: ' + message);
        // 堆栈：格式化为 at className.methodName(fileName:lineNumber)
        if (Array.isArray(obj.stackTrace)) {
          obj.stackTrace.forEach(t => {
            lines.push(
              '\tat ' + t.className + '.' + t.methodName +
              '(' + t.fileName + ':' + t.lineNumber + ')'
            );
          });
        }
        return lines.join('\n');
      } catch (e) {
        // 解析失败则原样返回
        return msg;
      }
    },
  },

  methods: {
    theLogInstanceChange(id){
      this.srelMethod=id;
      this.getSysMsgErrorGlobalList({currentPage:1,smegInstance:this.srelMethod});
    },
    // 打开详情弹窗，直接复用列表行数据，无需额外请求详情接口
    handelDetail(row) {
      this.detailRow = row;
      this.detailShow = true;
    },
    // 关闭详情弹窗并清空数据
    detailClose() {
      this.detailShow = false;
      this.detailRow = {};
    },
  },

  created() {
    this.getSysMsgErrorGlobalList();
  },
  mounted(){
    
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/data/MsgErrorGlobal.vue